import { Middleware } from "redux"
import RootState from "store/state"
import AnyAction from "store/anyActions"
import AppTypes from "store/app/app.types";
import ChatTypes from "store/chat/chat.types";
import { setCSSVar } from "utils";
import { IChatMessage } from "store/chat/chat.state";

const bchatMiddleware: Middleware<{}, RootState> = store => next => async (action: AnyAction) => {

    switch (action.type) {

        case AppTypes.INIT_APP_SUCCESS: {

            // chat message variables
            setCSSVar('--sa-general-font-family', "Roboto-Regular")
            setCSSVar('--sa-global-light-colour', '#3B83BF')
            setCSSVar('--sa-message-agent-text-colour', '#fff');
            setCSSVar('--sa-message-agent-timestamp-text-colour', '#fff');
            setCSSVar('--sa-message-customer-text-colour', '#000');
            setCSSVar('--sa-message-customer-timestamp-text-colour', '#000');
            setCSSVar('--sa-message-agent-border-width', '0');
            setCSSVar('--sa-message-customer-border-width', '0');

            return next(action)
        }

        case ChatTypes.ADD_CHAT_CONNECTION: {

            try {
                const response = await window.bchat.getChatSession(action.payload.initialContactId ?? action.payload.id, "AGENT");

                action.payload = {
                    ...action.payload,
                    ...response
                }

            } catch (err) {
                console.error('error getting chat session from bchat, is the chat being started via smartagent customer chat app?')
                return next(action)

            }

            return next(action)

        }

        case ChatTypes.RECIEVE_CHAT_MESSAGE: {

            try {
                const msg = action.payload.msg as IChatMessage
                if (msg.ParticipantRole !== 'CUSTOMER') return next(action)
                
                const response = await window.bchat.putChatMessage({
                    contactId: store.getState().chat.connections.find(c => c.id === action.payload.id)?.initialContactId ?? action.payload.id,
                    message: msg.content as string
                });
    
                if (response?.translatedMessage) {
                    const originalMessage = msg.content;
                    msg.content = response.translatedMessage
                    msg.OriginalMessage = originalMessage
                }

            } catch {
                return next(action)
            }

            return next(action)
        }
        default:
            return next(action)
    }

}

export default bchatMiddleware
